import { render, staticRenderFns } from "./alonelAsOverview.vue?vue&type=template&id=2e3d5672&scoped=true&"
import script from "./alonelAsOverview.vue?vue&type=script&lang=ts&"
export * from "./alonelAsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./alonelAsOverview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./alonelAsOverview.vue?vue&type=style&index=1&id=2e3d5672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d5672",
  null
  
)

export default component.exports